/**
 * Fonctions supplémentaires de l'objet natif string
 */

/**
 * Retourne la chaîne après avoir remplacé le premier caractère par sa majuscule
 *
 * @returns {string}
 */
String.prototype.ucfirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
